<template>
  <div class="product-subscribe-form">
    <ModalComponentHeader>
      {{ messages.informAvailability }}
    </ModalComponentHeader>
    <ModalComponentBody>
      <form class="subscribe-form" @submit.prevent="informAvailability">
        <p class="subscribe-form__text">
          {{ messages?.informText }}
        </p>
        <DefEmail name="email" :placeholder="messages.email" :value="userEmail" :required="true" />
        <!--        <DefPhone-->
        <!--          :placeholder="messages.phone"-->
        <!--          :name="'phone'"-->
        <!--          :value="userPhone"-->
        <!--          :only-countries="['UA']"-->
        <!--          :required="true"-->
        <!--        />-->
        <DefButtonPrimary :type="'submit'">
          {{ messages?.informButton }}
        </DefButtonPrimary>
      </form>
    </ModalComponentBody>
  </div>
</template>

<script lang="ts" setup>
import { useStore } from '@/store';
import { computed } from 'vue';
import ProductInformAvailability from '@components/Product/Modals/ProductInformAvailability.vue';
import useModal from '@use/useModal/useModal';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import ModalComponentHeader from '@use/useModal/ModalComponentHeader.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import DefEmail from '@components/Def/DefEmail/DefEmail.vue';

const { state, dispatch, getters } = useStore();
const modal = useModal();

const messages = computed(() => state.product.data.messages);
const product = computed(() => state.product.data.product);
const userEmail = computed(() => state.personal.data.authInfo?.user_email);
const globalRoutes = computed(() => state.results?.routes);

const handlerShowResponseModal = (result) => {
  modal.show(ProductInformAvailability, { result }, { width: '328px', widthTablet: '400px' });
};
const id = computed(() => getters['product/id']);

const informAvailability = async ({ target }) => {
  const formData = new FormData(target);
  try {
    const routes = globalRoutes.value.product?.informAvailabilityByEmail;

    const {
      path,
      'params-example-data': { action },
    } = routes;

    if (action && path) {
      formData.append('action', action);
      formData.append('offerId', id.value);
      formData.append('productId', product.value?.id);
      // formData.append('LANGUAGE_ID', this.lang.LANGUAGE_ID);

      const { status, data } = await axios.post(path, formData);

      handlerShowResponseModal(data);

      if (status !== 200) {
        throw `bad request response status: ${status} \n url: ${path}`;
      }
    } else {
      throw `action: ${action} or path: ${path} is empty`;
    }
  } catch (err) {
    console.error(err);
  }
};
</script>

<style lang="scss" scoped>
.product-subscribe-form {
}
.subscribe-form {
  &__text {
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    margin-bottom: 16px;
    @include point-md {
      margin-bottom: 24px;
      font-size: 16px;
    }
  }
  :deep(.def-button-primary) {
    margin-top: 16px;
    width: 100%;
  }
  :deep(.def-email) {
    width: 100%;
  }
}
</style>
